import React, { Component } from "react";
import { connect } from "react-redux";
import PickupForm from "../containers/PickupForm";
import Header from "../components/Header";
import {goToView} from '../redux/actions/ui'
import {setInfoHelpPage} from '../redux/actions/infoHelp'
import locale from '../utils/locale';

class PickupFormView extends Component {
  goToHelpPage = () =>{
    this.props.goToView('InfoHelpView');
    this.props.setInfoHelpPage(locale("callMeMessage", this.props.yardPhoneNumber), "", true);
  }

  render() {
    const { logo, isSellerLogoOn } = this.props
    return (
      <div>
        <Header onHelpClick={this.goToHelpPage} logo={logo} hideInfoText={!isSellerLogoOn}/>
        <PickupForm />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  yardPhoneNumber: state.lot.yardPhoneNumber,
  logo: state.lot.logo,
  isSellerLogoOn: state.lot.isSellerLogoOn
});
const mapDispatchToProps = {setInfoHelpPage, goToView};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PickupFormView);



// WEBPACK FOOTER //
// ./src/views/PickupFormView.js